import React from 'react';
import { Input } from 'antd';
import PropertyEditor from "../PropertyEditor";

export default class ReadonlyEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {

        return (
            <Input disabled={true} value={this.props.source.value} title={this.props.source.value} />
        );
    }
}